module.exports = __webpack_public_path__ + "img/bg_ai_intelligent.9c0ec43f.gif";